import { render } from "./VQIs.vue?vue&type=template&id=1e272444"
import script from "./VQIs.vue?vue&type=script&lang=js"
export * from "./VQIs.vue?vue&type=script&lang=js"

import exportComponent from "/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__